<template>
  <div id="app">
    <router-view />
    <update-password></update-password>
  </div>
</template>

<script>
import updatePassword from '@/components/update-password/update-password';
export default {
  name: 'App',
  data () {
    return {}
  },
  components: {
    updatePassword
  },
  methods: {

  },
  mounted() {

  },
};
</script>

<style lang="scss">
@import url(./components/emoji-input/source/css/sprite.css);
</style>

<style>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body,
html {
  width: 100%;
  height: 100%;
}
.el-loading-mask {
  z-index: 1000;
}
.el-input.is-disabled .el-input__inner {
  color: #909399;
}
.el-range-editor--small .el-range-separator {
  padding: 0;
}
body .el-table th.gutter {  display: table-cell !important;}
body .el-table colgroup.gutter {  display: table-cell !important;}

#app [disabled] {
  color: #666;
  text-fill-color: #666;
  -webkit-text-fill-color: #666;
  background: #fafafa;
}
#app .ivu-select-disabled .ivu-select-selection {
  box-sizing: revert;
}
</style>



// WEBPACK FOOTER //
// src/App.vue